(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esc-collab-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  var mq=window.matchMedia('(max-width:599px)');
  function build(){
    if(!mq.matches)return;
    document.querySelectorAll('.esc-cs__grid').forEach(function(g){
      if(g.dataset.swipeDone)return; g.dataset.swipeDone='1';
      var run=[];
      function flush(){
        if(run.length>1){
          var w=document.createElement('div');w.className=run.length===2?'esc-cs__pair':'esc-cs__swipe';
          run[0].parentNode.insertBefore(w,run[0]);
          run.forEach(function(f){w.appendChild(f);});
        }
        run=[];
      }
      Array.prototype.slice.call(g.children).forEach(function(c){
        if(c.tagName==='FIGURE'&&c.classList.contains('esc-cs__cell')){
          var k=(c.className.match(/esc-cs__cell--(\w[\w-]*)/)||[])[1]||'';
          if(run.length&&run[0].__k!==k)flush();
          c.__k=k;run.push(c);
        }else flush();
      });
      flush();
    });
  }
  if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esc-collection-row"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-esc-crow]').forEach(function (root) {
  var tabs = root.querySelectorAll('.esc-crow__tab');
  if (!tabs.length) return;
  var cells = root.querySelectorAll('.esc-crow__cell[data-tab]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var want = tab.getAttribute('data-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      cells.forEach(function (cell) {
        cell.hidden = cell.getAttribute('data-tab') !== want;
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
